import { createAsyncThunk } from '@reduxjs/toolkit';
import AssignmentReasonApi from '@infrastructure/assignment-reason-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const GetAllAssignmentReasonAsync = createAsyncThunk('assignmentReason/GetAllAssignmentReason', async (_, { rejectWithValue }) => {
    try {
        const response = await AssignmentReasonApi.GetAllAssignmentReason();
        return response.data;
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const GetAssignmentReasonByClientTaskNumberAsync = createAsyncThunk('assignmentReason/GetAssignmentReasonByClientTaskNumber', async (clientId, { rejectWithValue }) => {
    try {
        const response = await AssignmentReasonApi.GetAssignmentReasonByClientTaskNumber(clientId);
        return response.data;
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const CreateAssignmentReasonAsync = createAsyncThunk('assignmentReason/CreateAssignmentReason', async (payload, { rejectWithValue }) => {
    try {
        const response = await AssignmentReasonApi.CreateAssignmentReason(payload);
        return response.data;
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const UpdateAssignmentReasonAsync = createAsyncThunk('assignmentReason/UpdateAssignmentReason', async (payload, { rejectWithValue }) => {
    try {
        const response = await AssignmentReasonApi.UpdateAssignmentReason(payload);
        return response.data;
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const UpdateAssignmentReasonStatusAsync = createAsyncThunk('assignmentReason/UpdateAssignmentReasonStatus', async ({ id, payload }, { rejectWithValue }) => {
    try {
        const response = await AssignmentReasonApi.UpdateAssignmentReasonStatus(id, payload);
        return response.data;
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const DeleteAssignmentReasonAsync = createAsyncThunk('assignmentReason/DeleteAssignmentReason', async (id, { rejectWithValue }) => {
    try {
        await AssignmentReasonApi.DeleteAssignmentReason(id);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
